import { useRoute } from 'vue-router'
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useSwapStore from '../store/swap'
import useAuthStore from '@/modules/Auth/store'
import useToastStore from '@/modules/Core/store/toast'
import useAuth from '@/modules/Auth/composables/useAuth'
import featureFlag from '@/config/featureFlag'

export default function useSwap() {
  const swapStore = useSwapStore()
  const route = useRoute()
  const toastStore = useToastStore()
  const { t } = useI18n()
  const { loginWithRedirect } = useAuth()

  async function handleSwap(swap: string) {
    const authStore = useAuthStore()
    const isLoggedIn = authStore.loggedIn

    swapStore.setSwapId(swap)

    if (isLoggedIn) {
      swapStore.toggleSwapModal(true)
    } else {
      toastStore.addToast({
        title: t('messages.swapLoginMessage'),
        color: 'success',
      })

      if (featureFlag.authMode === 'legacy') {
        authStore.toggleAuthForm(true)
      } else {
        await loginWithRedirect()
      }
    }
  }

  watch(
    () => route.query,
    (query) => {
      if (!query) {
        return
      }

      const swapId = query?.swap ?? ''

      if (swapId && typeof swapId === 'string' && swapId.trim() !== '') {
        handleSwap(swapId)
      }
    },
    { immediate: true }
  )

  return {}
}
